// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operators-list__name {
    cursor: pointer;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none;   /* Chrome/Safari/Opera */
    -khtml-user-select: none;    /* Konqueror */
    -moz-user-select: none;      /* Firefox */
    -ms-user-select: none;       /* Internet Explorer/Edge */
    user-select: none;           /* Non-prefixed version, currently not supported by any browser */
}

.operators-list {
    height: calc(100% - 6rem);
    display: flex;
    flex-direction: column;
    overflow: auto;
    position: relative;
}

.operators-list .operators-list__btn-create {
    float: left;
    margin: 1.5rem 4rem;
}

.operators-list .operators-list__btn-cancel-create {
    background-color: #d22e37;
    float: left;
    margin: 1.5rem 4rem;
    margin-left: -2rem;
}

.operators-list .operators-list__avatar-cell {
    width: 7rem;
}

.operators-list .operators-list__buttons-cell {
    width: 5%;
}

`, "",{"version":3,"sources":["webpack://./src/app/operator/operators-main/operators-list/OperatorsList.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,IAAI,wBAAwB;IACrD,wBAAwB,KAAK,cAAc;IAC3C,sBAAsB,OAAO,YAAY;IACzC,qBAAqB,QAAQ,2BAA2B;IACxD,iBAAiB,YAAY,iEAAiE;AAClG;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb","sourcesContent":[".operators-list__name {\r\n    cursor: pointer;\r\n    -webkit-touch-callout: none; /* iOS Safari */\r\n    -webkit-user-select: none;   /* Chrome/Safari/Opera */\r\n    -khtml-user-select: none;    /* Konqueror */\r\n    -moz-user-select: none;      /* Firefox */\r\n    -ms-user-select: none;       /* Internet Explorer/Edge */\r\n    user-select: none;           /* Non-prefixed version, currently not supported by any browser */\r\n}\r\n\r\n.operators-list {\r\n    height: calc(100% - 6rem);\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: auto;\r\n    position: relative;\r\n}\r\n\r\n.operators-list .operators-list__btn-create {\r\n    float: left;\r\n    margin: 1.5rem 4rem;\r\n}\r\n\r\n.operators-list .operators-list__btn-cancel-create {\r\n    background-color: #d22e37;\r\n    float: left;\r\n    margin: 1.5rem 4rem;\r\n    margin-left: -2rem;\r\n}\r\n\r\n.operators-list .operators-list__avatar-cell {\r\n    width: 7rem;\r\n}\r\n\r\n.operators-list .operators-list__buttons-cell {\r\n    width: 5%;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
